/**
 * KonfidenzBadge — the match-confidence value badge for the Police-Zuordnung card
 * (Story UI-U4). Ported from the prototype konfidenz.tsx onto our Badge primitive.
 *
 * Thresholds (design contract): ≥90 % → success (grün) · 70–89 % → info (blau) ·
 * <70 % → warning (orange, "Zuordnung unsicher"). Soft badge (tinted fill + border).
 *
 * [Source: brokly-design-reference/components/brokly/konfidenz.tsx]
 * [Source: docs/design/2026-07-10_sebastian-package/design.md §2/§5]
 */
import { Badge, type BadgeVariant } from '../../../components/ui/Badge';

/** Confidence % → soft-badge tone (≥90 success · 70–89 info · <70 warning). */
export function konfidenzVariant(value: number): BadgeVariant {
  if (value >= 90) return 'success';
  if (value >= 70) return 'info';
  return 'warning';
}

export function KonfidenzBadge({
  value,
  label,
  className,
}: {
  /** Confidence as a whole-number percent (e.g. 70). */
  value: number;
  /** Optional prefix (e.g. "Konfidenz"). */
  label?: string;
  className?: string;
}) {
  return (
    <Badge variant={konfidenzVariant(value)} className={className}>
      {label ? `${label} ` : ''}
      {value} %
    </Badge>
  );
}
